import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Time = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M18.5 5H20V3H4V5L5.5 5V5.5C5.5 8.46848 7.4899 10.9722 10.2086 11.75C7.4899 12.5278 5.5 15.0315 5.5 18V19H4V21H20V19H18.5V18C18.5 15.0315 16.5101 12.5278 13.7914 11.75C16.5101 10.9722 18.5 8.46848 18.5 5.5V5ZM16.5 5L7.5 5V5.5C7.5 7.98528 9.51472 10 12 10C14.4853 10 16.5 7.98528 16.5 5.5V5ZM16.5 18V19H7.5V18C7.5 15.5147 9.51472 13.5 12 13.5C14.4853 13.5 16.5 15.5147 16.5 18Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Time;
